import { clientApi } from 'api';

export const checkEmailExists = (isServer = false) => async (email: string) => {
  const { data } = await clientApi.post(`/users/check-email`, { email });

  return data;
};
